export enum FormAttributionAttributes {
  FormEnabled = 'data-track-form-enabled',
  FormName = 'data-track-form-name',
  FieldName = 'data-track-field-name',
}

export enum FormAttributionInteraction {
  Fill = 'filled',
  Clear = 'cleared',
  Click = 'click',
}

export enum FormAttributionElement {
  Radio = 'radio-button',
  Checkbox = 'check-box',
  Select = 'select',
}

export enum FormAttributionBoolean {
  True = 'ja',
  False = 'nein',
}
